export default {
  methods: {
    getStateParam: function(param) {
      this.stateParams = new URLSearchParams(window.location.search);

      return this.stateParams.get(param);
    },

    getFilterState: function() {
      return this.getStateParam("v-filter");
    },

    initStateFilter: function() {
      // Handle default state filter
      let stateFilter = this.getFilterState();

      if (stateFilter) {
        stateFilter = JSON.parse(stateFilter);
      }

      this.filter = (stateFilter) ? stateFilter : this.defaultFilter || {};

      this.filter.historical = this.filter.historical || false;
    },

    setFilterState: function() {
      if (this.isInitialized) {
        let filterState = Object.assign({}, this.filter);

        Object.keys(filterState).forEach((key) => {
          var el = filterState[key];

          if (el && el.constructor === Array && el.length <= 0) {
            delete filterState[key];
          }

          if (el.constructor === Object && Object.keys(el).length <= 0) {
            delete filterState[key];
          }
        });

        app.ui.state.update({
          "v-filter": JSON.stringify(filterState),
          "v-page": null
        });

        // Trigger UI stateupdade event
        window.dispatchEvent(new Event("updatestate"));
      }
    },

    setFilter: function() {
      if (this.isInitialized) {
        this.setFilterOptions();

        this.setFilterState();
      }
    },
  }
}